import React from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Tag } from 'primereact/tag';
import { useLanguage } from '../../../../../contexts/LanguageContext';
import { resolveApprovalStatusText, approvalStatusSeverity, ApprovalStatus } from '../../../../../utils/dealerApprovalEnums';
import { dateOnlyBodyTemplate } from '../../../../../utils/dateUtils';

const DealerRegistrationTable = ({ items, loading, totalCount, pagination, onPageChange, onOpen }) => {
    const { th } = useLanguage();

    const overallStatusBody = (row) => <Tag value={resolveApprovalStatusText(th, row.overallStatus)} severity={approvalStatusSeverity(row.overallStatus)} />;

    const approvalStepBody = (row) => {
        if (row.overallStatus === ApprovalStatus.PENDING && row.approvalStatus != null) {
            return <span>{`${th('dealerApproval.step')} ${row.approvalStatus}`}</span>;
        }
        return <span>-</span>;
    };

    const addressesBody = (row) => {
        const list = Array.isArray(row.addresses) ? row.addresses : [];
        const count = row.addressCount ?? list.length;
        const tags =
            list.length > 0
                ? list.map((a) => (
                      <Tag key={a.dealerAddressBrandId ?? `${a.sapAddrId}-${a.brandId}`} value={`${a.addressName || a.sapAddrId || ''} - ${a.brandName || a.brandId || ''}`} severity={a.isActive === false || a.isActive === 0 ? 'secondary' : 'info'} />
                  ))
                : row.addressName || row.brandName
                ? [<Tag key="primary" value={`${row.addressName || ''} - ${row.brandName || ''}`} severity="info" />]
                : [];
        return (
            <div className="flex flex-column gap-1">
                <span className="text-sm">{th('dealerRegistration.addressCount', { count })}</span>
                <div className="flex flex-wrap gap-1">{tags}</div>
            </div>
        );
    };

    const actionBody = (row) => {
        const isPending = row.overallStatus === ApprovalStatus.PENDING;
        return (
            <div className="flex align-items-center justify-content-center gap-3">
                <i onClick={() => onOpen(row)} className={`pi ${isPending ? 'pi-eye' : 'pi-pencil'} cursor-pointer text-blue-500 hover:text-blue-700`} style={{ fontSize: '1.1rem' }} title={isPending ? th('common.view') : th('common.edit')} />
            </div>
        );
    };

    return (
        <DataTable
            value={items}
            loading={loading}
            lazy
            paginator
            rows={pagination.rows}
            first={pagination.first}
            totalRecords={totalCount}
            onPage={onPageChange}
            dataKey="sapDealerId"
            emptyMessage={th('common.noRecords')}
            showGridlines
            stripedRows
            tableStyle={{ minWidth: '50rem' }}
            rowsPerPageOptions={[5, 10, 25, 50, 100]}
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
            currentPageReportTemplate={th('table.paginatorTemplate')}
        >
            <Column body={actionBody} exportable={false} bodyClassName="text-center" headerClassName="text-center" style={{ width: '5%', minWidth: '53px' }} />
            <Column field="dealerName" header={th('dealerRegistration.column.dealerName')} />
            <Column header={th('dealerRegistration.column.addressName')} body={addressesBody} />
            <Column header={th('dealerRegistration.column.overallStatus')} body={overallStatusBody} />
            <Column header={th('dealerRegistration.column.approvalStatus')} body={approvalStepBody} />
            <Column field="createdName" header={th('dealerRegistration.column.createdName')} />
            <Column header={th('dealerRegistration.column.createdDate')} body={(row) => dateOnlyBodyTemplate(row, 'createdDate')} />
        </DataTable>
    );
};

export default DealerRegistrationTable;
